module.exports = __webpack_public_path__ + "static/img/bg_p.a2343dd9.png";